import {BootstrapButton, BootstrapModal} from '../react-bootstrap'
import {sum, renderErrors, bindState} from '../utils'


export class PasswordResetBeginForm extends React.Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);

        this.state = {data: {}};
        this.bindState = bindState;
    }
    componentWillUnmount () {
        this.xhr && this.xhr.abort();
    }
    render() {
        return (
            <div className="row">
                <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
                    <h2>Password reset</h2>
                    <hr />
                    <p>Forgotten your password? Enter your email address below, and we'll email instructions for setting a new one.</p>
                    {renderErrors(this.state.errors && this.state.errors._overall_)}
                    <form action="" onSubmit={this.onSubmit}>
                        <div className="row">
                            <div className="col-md-10 col-lg-8">
                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <input className="form-control" name="email" value={this.state.data.email} onChange={this.bindState('data.email')} placeholder="Email" />
                                    {renderErrors(this.state.errors && this.state.errors.email)}
                                </div>
                            </div>
                        </div>
                        <button type="submit" className="btn btn-primary">Reset my password</button>
                    </form>
                </div>
            </div>
        )
    }
    onSubmit (e) {
        e.preventDefault();
        var data = this.state.data;
        this.xhr = $.postJSON('/users/password_reset/begin', data).done(data => {
            window.location = '/users/password_reset/email_sent';
        }).fail((xhr, textStatus, errorThrown) => {
            if (xhr.status === 400) {
                this.setState(xhr.responseJSON)
            } else {
                this.setState({errors: {_overall_: ['Operation failed.']}})
            }
        }).always(() => this.xhr = null);
    }

}


export class PasswordResetConfirmForm extends React.Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);

        this.state = {data: {}};
        this.bindState = bindState;
    }
    componentWillUnmount () {
        this.xhr && this.xhr.abort();
    }
    render() {
        return (
            <div className="row">
                <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
                    <h2>Enter new password</h2>
                    <hr />
                    <p>Please enter your new password twice so we can verify you typed it in correctly.</p>
                    {renderErrors(this.state.errors && this.state.errors._overall_)}
                    <form method="POST" action="" autoComplete="off" onSubmit={this.onSubmit}>
                        <div className="row">
                            <div className="col-md-10 col-lg-8">
                                <div className="form-group">
                                    <label htmlFor="new_password">New password</label>
                                    <input type="password" className="form-control" name="new_password" value={this.state.data.new_password} onChange={this.bindState('data.new_password')} placeholder="New password" />
                                    {renderErrors(this.state.errors && this.state.errors.new_password)}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-10 col-lg-8">
                                <div className="form-group">
                                    <label htmlFor="new_password_again">New password again</label>
                                    <input type="password" className="form-control" name="new_password_again" value={this.state.data.new_password_again} onChange={this.bindState('data.new_password_again')} placeholder="New password again" />
                                    {renderErrors(this.state.errors && this.state.errors.new_password_again)}
                                </div>
                            </div>
                        </div>
                        <button type="submit" className="btn btn-primary">Change my password</button>
                    </form>
                </div>
            </div>
        )
    }
    onSubmit (e) {
        e.preventDefault();
        var data = this.state.data;
        this.xhr = $.postJSON(window.location, data).done(data => {
            window.location = '/users/password_reset/complete';
        }).fail((xhr, textStatus, errorThrown) => {
            if (xhr.status === 400) {
                this.setState(xhr.responseJSON)
            } else {
                this.setState({errors: {_overall_: ['Operation failed.']}})
            }
        }).always(() => this.xhr = null);
    }

}

